import { DateTime } from 'luxon'

function generateTextFromComparisons(
  a: number,
  b: number,
  verbiage: string[]
): string {
  if (a > b) {
    return verbiage[2]
  } else if (a === b) {
    return verbiage[1]
  } else {
    return verbiage[0]
  }
}

function formatCurrency(value: number): string {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
}

function formatCurrencyShort(value: number): string {
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    style: 'currency',
    currency: 'USD'
  }).format(value)
}

function formatNumericValue(value: number): string {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  })
}

function getMonthFromDate(d: string | Date) {
  let date: DateTime

  if (typeof d === 'string') {
    // Custom format 'yyyy-MM-dd HH:mm:ss'
    date = DateTime.fromFormat(d, 'yyyy-MM-dd HH:mm:ss')
  } else {
    date = DateTime.fromJSDate(d)
  }

  if (!date.isValid) {
    throw new Error('Invalid DateTime')
  }

  return date.toFormat('MMMM')
}

function getYearFromDate(d: string | Date) {
  const date = new Date(d)
  return date.getFullYear()
}

function getBeginingOfTheMonthsAgoDate(monthsAgo: number) {
  const date = DateTime.local().minus({ months: monthsAgo }).startOf('month')
  return date.toJSDate()
}

function getRandomItem(arr: any[]) {
  const randomIndex = Math.floor(Math.random() * arr.length)

  const item = arr[randomIndex]

  return item
}

function formatPercentage(value: number): string {
  if (!value && value !== 0) {
    return '-'
  }

  return value.toLocaleString('en-US', {
    style: 'percent',
    maximumFractionDigits: 1
  })
}

const housingMarketUtils = {
  getRandomItem,
  formatCurrency,
  getYearFromDate,
  formatPercentage,
  getMonthFromDate,
  formatNumericValue,
  formatCurrencyShort,
  generateTextFromComparisons,
  getBeginingOfTheMonthsAgoDate
}

export default housingMarketUtils
